import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ChatBoxMessagesComponent } from './components/chat-box-messages/chat-box-messages.component';
import { ChatBoxInputComponent } from './components/chat-box-input/chat-box-input.component';
import { ChatBoxService } from './services/chat-box.service';
import { TranslateModule } from '@ngx-translate/core';
import { ChatBoxComponent } from './components/chat-box/chat-box.component';
import { AppMaterialModule } from 'src/app/modules/app-material.module';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    TranslateModule,
    AppMaterialModule,
  ],
  declarations: [
    ChatBoxComponent,
    ChatBoxMessagesComponent,
    ChatBoxInputComponent
  ],
  exports: [
    ChatBoxComponent
  ],
  providers: [
    ChatBoxService
  ],
})
export class ChatBoxModule { }
